import { LocalStorageKeys, Session } from 'src/types/common';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from 'src/utils/localStorage';

export function removeStorageSessionData() {
  localStorage.removeItem(LocalStorageKeys.Session);
  localStorage.removeItem(LocalStorageKeys.WalletReadToken);
}

export function getStorageSession() {
  return getLocalStorageItem(LocalStorageKeys.Session);
}

export function updateStorageSession(session: Session) {
  return setLocalStorageItem(LocalStorageKeys.Session, session);
}
